/* Cartao de emails do convidado (page.evento; R28, decisao 66 do dono).
 *
 * Quem abre o convite deixa o email e passa a receber os avisos do evento
 * (mudanca de data ou de local, cancelamento e os lembretes), com um email de
 * confirmacao. Varios emails por convite, cada um com "Remover". Logado, um
 * toque recebe no email da conta. A opcao das novidades da Montzel vai junto e
 * so vale depois da dupla confirmacao, que e do painel.
 *
 * MODULO PROPRIO, fora do mw-evento.js, que esta no teto de 78KB: este arquivo
 * tem teto proprio em scripts/check-js-budget.mjs. Ele e carregado com `defer`
 * ANTES do mw-evento.js (os deferidos rodam na ordem do documento), entao o
 * window.MWEvEmails ja existe quando o boot da pagina chega ao convite. O
 * mw-evento.js chama MWEvEmails({ v, j, c, r }) no fim de pintarConvite():
 *   v  o no da vista do convidado (template data-tpl="convite")
 *   j  a resposta do POST /convite/ver (st.vinc), com `inscritos`,
 *      `contaEmail` e `contaInscrita` na raiz (so no v=2)
 *   c  corpoAcesso: monta { c: token } ou { e: id } + o que vier; o token vive
 *      em closure no mw-evento.js e nunca passa por aqui como valor solto
 *   r  verConvite: recarrega a vista inteira
 * A chamada acontece uma vez por vista montada; o cartao guarda o estado dele
 * no proprio no e escreve de volta em `j` (a lista e a inscricao da conta)
 * depois de cada operacao, para uma remontagem nunca mostrar a lista velha.
 *
 * Contrato das rotas (painel, F3 da R28): POST convite/inscrever?v=2 com
 * { c|e, email | conta: true, novidades? } e POST convite/desinscrever?v=2 com
 * { c|e, id }; as duas devolvem { ok, inscritos: [{ id, m, conta?, p? }] },
 * com `m` = o email mascarado. Sem o contrato novo (painel antigo: `ver` sem
 * `inscritos`), com o evento cancelado ou ja realizado, o cartao nao aparece.
 *
 * A volta do login NAO e mais daqui (R30, parte E): a marca mw_ev_ins e o
 * inscrever {conta: true} da volta sairam. Quem liga o convite na volta e o
 * mw-evento.js, pelo POST convite/vincular (marca mw_ev_lig), e o vincular do
 * painel ja cria a inscricao da conta. Enquanto o convite pode ser guardado
 * (`podeVincular`), o botao da conta tambem some: o caminho da conta e o
 * "Guardar este convite na sua conta", que liga e inscreve num toque so.
 *
 * Textos: os fixos vem no markup da section (filtro t:); os que o JS escolhe
 * vem do bloco JSON #mw-evento-i18n-insc, que sai SEMPRE (fora do
 * {% if customer %}: quem abre o convite pode nao ter conta). Chave pedida e
 * nao encontrada vai para window.__mwEvI18nFaltando, como no mw-evento.js e no
 * mw-recorte.js. A leitura e preguicosa de proposito: o mw-evento.js RECRIA
 * esse array no boot dele, que roda depois deste arquivo.
 *
 * ES5 de proposito (var, function, sem ?., ??): o iPad do dono esta no iOS 12. */
(function () {
  'use strict';
  var W = window, D = document;
  var root = D.querySelector('[data-mw-evento]');
  if (!root || W.MWEvEmails) return;

  var API = '/apps/curador/eventos/convite/';
  var LOGADO = root.getAttribute('data-logado') === 'true';
  /* a mesma regra do texto de erro: @ e um dominio com ponto. Quem decide de
     verdade e o servidor (400 email_invalido). */
  var RE_EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var T = null;
  /* a frase de "Pronto" que atravessa a recarga da vista (o botao da conta, que
     liga o convite a conta e por isso recarrega tudo) */
  var aviso = '';

  function lerT() {
    if (T) return;
    var o = {}, F = W.__mwEvI18nFaltando || (W.__mwEvI18nFaltando = []);
    try { o = JSON.parse(D.getElementById('mw-evento-i18n-insc').textContent); } catch (e) {}
    T = W.Proxy ? new Proxy(o, {
      get: function (a, k) {
        if (typeof k === 'string' && !(k in a) && F.indexOf(k) < 0) F.push(k);
        return a[k];
      }
    }) : o;
  }
  /* atributo: valor `null` apaga */
  function at(e, n, v) { if (v == null) e.removeAttribute(n); else e.setAttribute(n, v); }
  function hd(e, oculto) { at(e, 'hidden', oculto ? '' : null); }
  function q(n, s) { return n.querySelector(s); }
  function sl(n, nome) { return q(n, '[data-slot="' + nome + '"]'); }
  function ac(n, nome) { return q(n, '[data-a="' + nome + '"]'); }
  function campo(n, nome) { return q(n, '[data-f="' + nome + '"]'); }
  function fmt(s, m) {
    return String(s || '').replace(/%(\w+)/g, function (_, k) { return m[k] != null ? m[k] : ''; });
  }
  function temConta(l) {
    for (var i = 0; i < l.length; i++) if (l[i].conta) return true;
    return false;
  }

  function pedir(rota, corpo) {
    return fetch(API + rota + '?v=2', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      return r.json().then(null, function () {}).then(function (j) {
        j = j && typeof j === 'object' ? j : {};
        /* resposta boa sem a lista e resposta que o cartao nao sabe desenhar */
        j._ok = r.ok && !!j.ok && Array.isArray(j.inscritos);
        return j;
      });
    });
  }

  /* ---------------- desenho ---------------- */
  /* O estado base sai da resposta: `logado` quando a conta tem email conhecido
     e ainda nao esta na lista (o botao da conta e o primario e o campo fica
     atras do "Usar outro email"); `vazio` nos outros casos (o campo aparece).
     `enviando` e `pronto` sao passageiros, gravados por quem chama.
     Com `podeVincular` o botao da conta nao aparece (R30, parte E): ele ligava
     o convite sem dizer, e quem liga agora e o "Guardar" do mw-evento.js. Com
     `recusado` tambem (o "Guardar" aparece para quem desligou antes, e os dois
     juntos seriam duas portas para a mesma coisa). Com o convite ja ligado a
     conta mas sem aviso, ele continua. */
  function ui(cd, est) {
    var j = cd._d.j, conta = LOGADO && !!j.contaEmail && !j.contaInscrita && !j.podeVincular && !j.recusado;
    at(cd, 'data-estado', est || (conta ? 'logado' : 'vazio'));
    hd(sl(cd, 'insc-acoes'), !conta);
    ac(cd, 'insc-conta').textContent = fmt(T.cta_conta, { email: j.contaEmail });
    at(ac(cd, 'insc-outro'), 'aria-expanded', cd._aberto ? 'true' : 'false');
    hd(sl(cd, 'insc-form'), conta && !cd._aberto);
    var ul = sl(cd, 'insc-lista'), tp = root.querySelector('template[data-tpl="insc-item"]');
    ul.textContent = '';
    /* A inscricao da conta pode chegar com `m` vazio (o painel ainda nao sabe
       o email da conta): a linha mostra so a etiqueta "sua conta", e o nome
       acessivel do "Remover" usa o texto da etiqueta no lugar do email. A de
       OUTRA pessoa com o email ainda desconhecido nao aparece: sem email nem
       etiqueta, a linha nao diria de quem e. */
    j.inscritos.forEach(function (x) {
      if (!x.m && !x.conta) return;
      var li = tp.content.firstElementChild.cloneNode(true), m = sl(li, 'insc-m'), sua = sl(li, 'insc-sua');
      at(li, 'data-id', x.id);
      li._m = x.m;
      m.textContent = x.m || '';
      hd(m, !x.m);
      hd(sua, !x.conta);
      at(ac(li, 'insc-remover'), 'aria-label', fmt(T.remover_aria, { email: x.m || sua.textContent }));
      ul.appendChild(li);
    });
    hd(sl(cd, 'insc-lbox'), !j.inscritos.length);
  }
  function status(cd, txt) { sl(cd, 'insc-status').textContent = txt || ''; }
  /* O erro fica FORA do formulario (ele tambem serve o botao da conta). Ele so
     entra no `aria-describedby` do campo quando e dele e quando esta visivel. */
  function erro(cd, txt, doCampo) {
    var p = q(cd, '[data-erro="insc"]'), inp = campo(cd, 'insc-email'), meu = txt && doCampo;
    p.textContent = txt || '';
    hd(p, !txt);
    at(inp, 'aria-invalid', meu ? 'true' : null);
    at(inp, 'aria-describedby', meu ? p.id : null);
  }
  /* aria-disabled e nao disabled: o foco nao cai para o body no meio do envio */
  function ocupado(cd, sim) {
    var v = sim ? 'true' : null;
    cd._voo = sim;
    at(cd, 'aria-busy', v);
    if (sim) at(cd, 'data-estado', 'enviando');
    at(ac(cd, 'insc-enviar'), 'aria-disabled', v);
    at(ac(cd, 'insc-conta'), 'aria-disabled', v);
  }

  /* ---------------- rede ---------------- */
  /* erro do contrato -> frase. Rajada, queda e o que o cartao nao preve caem na
     frase de rede da casa; `nao_logado` (a sessao caiu entre o carregamento e
     o toque) volta ao estado deslogado, com o campo; cancelado, realizado e
     acesso que sumiu (convite removido, ou o token revogado por um link novo
     com a pagina aberta) recarregam a vista, que ja sabe o que mostrar. O
     `sou_eu` fica na frase de rede: o organizador nunca ve este cartao. */
  function falhou(cd, r, doCampo) {
    var e = r.erro;
    if (e === 'nao_logado') {
      LOGADO = false;
      ui(cd);
      return campo(cd, 'insc-email').focus();
    }
    if (e === 'evento_cancelado' || e === 'evento_realizado' || e === 'nao_encontrado' || e === 'convite_invalido') return cd._d.r();
    ui(cd);
    erro(cd, e === 'email_invalido' ? T.e_email : e === 'limite_inscritos' ? T.e_limite : e === 'teto' ? T.e_teto : T.erro_rede,
      doCampo && e === 'email_invalido');
  }
  function queda(cd) {
    ocupado(cd, 0);
    ui(cd);
    erro(cd, T.erro_rede);
  }
  /* `recarregar`: o botao da conta liga o convite a conta no painel, entao a
     vista inteira volta (o bloco do vinculo muda junto) e o "Pronto" aparece no
     cartao novo. */
  function enviar(cd, corpo, okTxt, recarregar) {
    if (cd._voo) return;
    var d = cd._d, j = d.j, nov = campo(cd, 'insc-novidades');
    corpo.novidades = nov.checked;
    erro(cd, '');
    status(cd, '');
    ocupado(cd, 1);
    pedir('inscrever', d.c(corpo)).then(function (r) {
      ocupado(cd, 0);
      if (!r._ok) return falhou(cd, r, !corpo.conta);
      j.inscritos = r.inscritos;
      j.contaInscrita = !!r.contaInscrita || temConta(r.inscritos);
      /* a opcao das novidades nunca passa de um email para o proximo */
      nov.checked = false;
      if (recarregar) {
        aviso = okTxt;
        return d.r();
      }
      campo(cd, 'insc-email').value = '';
      ui(cd, 'pronto');
      status(cd, okTxt);
    }, function () { queda(cd); });
  }
  /* depois de remover, o foco vai ao "Remover" que ocupou o lugar da linha que
     saiu; sem proxima linha, ao campo (ou ao botao da conta, com o campo
     recolhido) */
  function remover(cd, li) {
    if (cd._voo) return;
    var d = cd._d, j = d.j, m = li._m, i = [].indexOf.call(li.parentNode.children, li);
    erro(cd, '');
    status(cd, '');
    ocupado(cd, 1);
    pedir('desinscrever', d.c({ id: li.getAttribute('data-id') })).then(function (r) {
      ocupado(cd, 0);
      if (!r._ok) return falhou(cd, r, 0);
      j.inscritos = r.inscritos;
      j.contaInscrita = temConta(r.inscritos);
      ui(cd, 'pronto');
      status(cd, m ? fmt(T.removido, { email: m }) : T.removido_conta);
      var alvo = cd.querySelectorAll('[data-a="insc-remover"]')[i];
      if (!alvo) alvo = sl(cd, 'insc-form').hasAttribute('hidden') ? ac(cd, 'insc-conta') : campo(cd, 'insc-email');
      alvo.focus();
    }, function () { queda(cd); });
  }

  /* ---------------- ligar (uma vez por vista) ---------------- */
  function ligar(cd) {
    cd._ok = 1;
    var inp = campo(cd, 'insc-email');
    sl(cd, 'insc-form').addEventListener('submit', function (e) {
      e.preventDefault();
      var v = inp.value.trim();
      if (!RE_EMAIL.test(v)) {
        /* o "Pronto" do envio anterior nao fica na tela junto com o erro */
        status(cd, '');
        erro(cd, T.e_email, 1);
        return inp.focus();
      }
      enviar(cd, { email: v }, fmt(T.ok, { email: v }));
    });
    inp.addEventListener('input', function () { if (inp.hasAttribute('aria-invalid')) erro(cd, ''); });
    cd.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-a]'), a = b && b.getAttribute('data-a');
      if (a === 'insc-conta') enviar(cd, { conta: true }, T.ok_conta, 1);
      else if (a === 'insc-outro') {
        cd._aberto = !cd._aberto;
        ui(cd);
        if (cd._aberto) inp.focus();
      } else if (a === 'insc-remover') remover(cd, b.closest('li'));
    });
  }

  function pintar(d) {
    var cd = d.v && q(d.v, '[data-slot="insc"]'), av = aviso;
    aviso = '';
    if (!cd) return;
    lerT();
    var j = d.j || {}, ev = (j.vista || {}).evento || {}, l = j.inscritos;
    var fora = !Array.isArray(l) || !!ev.cancelado || ev.status === 'realizado';
    hd(cd, fora);
    if (fora) return;
    j.contaInscrita = !!j.contaInscrita || temConta(l);
    d.j = j;
    cd._d = d;
    if (!cd._ok) ligar(cd);
    ui(cd);
    /* o "Pronto" que atravessou a recarga: a vista inteira foi refeita, entao
       o foco vai ao status (tabindex -1 no markup) para o leitor de tela
       anunciar a frase e o teclado nao recomecar do topo da pagina */
    if (av) {
      status(cd, av);
      sl(cd, 'insc-status').focus();
    }
  }

  W.MWEvEmails = pintar;
})();
